// extracted by mini-css-extract-plugin
module.exports = {"styles":"App_styles__hIXQs"};